import React, { createContext, useContext, useState, useCallback } from 'react';

const GuidedTourContext = createContext();

export const GuidedTourProvider = ({ children }) => {
  const [activeTour, setActiveTour] = useState(null);
  const [stepIndex, setStepIndex] = useState(0);
  const [history, setHistory] = useState([]);

  const startTour = useCallback((tourConfig) => {
    setActiveTour(tourConfig);
    setStepIndex(0);
    setHistory([]);
  }, []);

  const endTour = useCallback(() => {
    setActiveTour(null);
    setStepIndex(0);
    setHistory([]);
  }, []);

  const nextStep = useCallback(() => {
    setStepIndex((i) => (activeTour && i < activeTour.steps.length - 1 ? i + 1 : i));
  }, [activeTour]);

  const prevStep = useCallback(() => {
    setStepIndex((i) => (i > 0 ? i - 1 : i));
  }, []);

  return (
    <GuidedTourContext.Provider value={{
      activeTour,
      stepIndex,
      startTour,
      endTour,
      nextStep,
      prevStep,
      history,
      setHistory
    }}>
      {children}
    </GuidedTourContext.Provider>
  );
};

export const useGuidedTour = () => useContext(GuidedTourContext);
